import { use } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import * as url from "../../../helpers/url_helper";
import Request from "../../../helpers/request";
import { ToastContainer } from "react-bootstrap";
import { Card, CardBody, Col, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import Select from "react-select";
import axios from "axios";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";

function TopUsersCityWise() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState<any>({ value: 5, label: "5" });
  const token = localStorage.getItem("Authorization");
  const [selectedCity, setSelectedCity] = useState<any>(null);

  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [error, setError] = useState<string>("");

  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const limitOptions = [
    { value: 5, label: "5" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  function handleLimit(value: any) {
    setLimit(value);
  }

  const fetchData = async () => {
    setLoading(true);

    try {
      const reqObj = {
        mode: "TOP_USERS_CITY_WISE",
        limit: limit.value,
        ...(selectedCity?.length
          ? { cityIds: selectedCity.map((c: any) => c.value) }
          : {}),
      };

      const response = await Request.post(
        `${url.BASE_URL}${url.DATE_WISE_STREAK_URL}`,
        reqObj,
      );

      setData(response.data?.data || []);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [limit, selectedCity]);

  const UserColumns = [
    {
      name: "City Name",
      selector: (row: any) => row.city || "-",
      cell: (row: any) => <div>{row?.city || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Users",
      selector: (row: any) => row?.users?.length ?? 0,
      cell: (row: any) => <div>{row?.users?.length ?? 0}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
  ];

  const Styles = {
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 28,
      height: 30,
      width: "100px",
      fontSize: "10px",
      boxShadow: "none",
    }),

    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: 28,
    }),

    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      fontWeight: "normal",
      zIndex: 9999,
    }),

    placeholder: (provided: any) => ({
      ...provided,
      color: "#6c757d",
      fontWeight: "normal",
      fontSize: "13px",
    }),

    singleValue: (provided: any) => ({
      ...provided,
      color: "#333",
      fontWeight: "normal",
      fontSize: "14px",
    }),
  };

  const baseSelectStyles = {
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      fontWeight: "normal",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "#6c757d",
      fontWeight: "normal",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#333",
      fontWeight: "normal",
    }),
    control: (provided: any) => ({
      ...provided,
      minHeight: "34px",
      height: "34px",
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: 32,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontSize: "12px",
      paddingTop: 5,
      paddingBottom: 4,
      paddingLeft: 8,
      paddingRight: 8,
    }),
  };

  const fetchCityOptions = async (keyword: string, force = false) => {
    if (!force && (!keyword || keyword.trim().length < 2)) {
      setCityOptions([]);
      return;
    }

    try {
      const res = await axios.get(
        `${url.BASE_URL}${url.GET_SEARCH_CITY_URL}?keyword=${encodeURIComponent(
          keyword,
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const list = res?.data?.data ?? res?.data ?? [];
      const mapped = Array.isArray(list)
        ? list
            .map((item: any) => {
              const value = item.id ?? item._id ?? item.value;
              const label = item.name ?? item.label ?? item.value;
              return value && label ? { value, label } : null;
            })
            .filter(Boolean)
        : [];

      setCityOptions(mapped);
      setError("");
    } catch (err) {
      console.error("City search failed", err);
      setCityOptions([]);
      setError("Failed to load cities");
    }
  };

  const handleSearch = (value: string) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchCityOptions(value);
    }, 400);
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col>
          <Card
            style={{
              marginTop: 30,
              marginLeft: 30,
              marginRight: 30,
              marginBottom: 0,
            }}
          >
            <CardBody>
              <Row>
                <Col>
                  <DataTable
                    columns={UserColumns}
                    data={data}
                    customStyles={customStyles}
                    expandableRows={true}
                    expandableRowsComponent={ExpandedComponent}
                    expandableIcon={{
                      collapsed: <ExpandCollapseIcon expanded={false} />,
                      expanded: <ExpandCollapseIcon expanded={true} />,
                    }}
                    subHeader
                    subHeaderComponent={
                      <div className="container-fluid p-0 pb-2">
                        <div className="d-flex justify-content-end align-items-end gap-3">
                          <div className="d-flex justify-content-start align-items-start me-auto">
                            <h5 className="fw-bold ">Top Users CityWise</h5>
                          </div>

                          <div className="d-flex justify-content-end align-items-end  gap-3">
                            <div style={{ minWidth: "230px" }}>
                              <Select
                                placeholder="Search and select city"
                                options={cityOptions}
                                value={selectedCity}
                                styles={baseSelectStyles}
                                isClearable
                                isMulti
                                menuPortalTarget={document.body}
                                onFocus={() => fetchCityOptions("", true)}
                                onChange={(opt: any) => setSelectedCity(opt)}
                                onInputChange={(inputValue, { action }) => {
                                  if (action === "input-change") {
                                    handleSearch(inputValue);
                                  }
                                  return inputValue;
                                }}
                              />

                              {error && (
                                <div className="text-danger small mt-1">
                                  {error}
                                </div>
                              )}
                            </div>
                            <Select
                              options={limitOptions}
                              onChange={handleLimit}
                              styles={Styles}
                              value={limit}
                              placeholder="Select Limit"
                            />
                          </div>
                        </div>
                      </div>
                    }
                  />
                </Col>
              </Row>
              {loading && <AirHomeLoader />}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default TopUsersCityWise;

export const ExpandedComponent = (data: any) => {
  const userColumns: any[] = [
    {
      name: "Name",
      selector: (row: any) =>
        row?.firstname && row?.lastname
          ? `${row.firstname} ${row.lastname}`
          : "-",
      cell: (row: any) =>
        row?.userId && row?.firstname && row?.lastname ? (
          <span className="">
            <a
              href={`/users/profile/${row.userId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${row.firstname} ${row.lastname}`}
            </a>
          </span>
        ) : (
          <span className="">{`${row.firstname} ${row.lastname}`}</span>
        ),
      sortable: true,
      grow: 2,
    },

    {
      name: "Phone Number",
      selector: (row: any) => row.mobile || "-",
      cell: (row: any) => <div>{row?.mobile || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Streak Count",
      selector: (row: any) => row.noOfStreak || "-",
      cell: (row: any) => <div>{row?.noOfStreak || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
  ];

  return (
    <div className="p-3">
      <DataTable
        columns={userColumns}
        data={data?.data?.users || []}
        dense
        highlightOnHover
        noDataComponent="No users available"
        customStyles={customStyles}
      />
    </div>
  );
};

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};
